<template>
  <div class="search-bar">
    <input
      type="text"
      :placeholder="placeholder"
      v-model="searchQuery"
      class="search-bar__input"
    />

    <i class="fa-regular fa-magnifying-glass" />
  </div>
</template>
<script setup lang="ts">
type searchBarProps = {
  placeholder: string;
};

const { placeholder } = defineProps<searchBarProps>();

const searchQuery = defineModel<string>("searchQuery");
</script>
<style lang="scss" scoped>
.search-bar {
  display: flex;
  padding: 8px 16px;
  justify-content: space-between;
  align-items: center;
  border-radius: 10px;
  border: 1px solid var(--clr-p2);
  &__input {
    border: none;
    background: none;
  }
}

/* clears the ‘X’ from Internet Explorer */
input[type="search"]::-ms-clear,
input[type="search"]::-ms-reveal {
  display: none;
  width: 0;
  height: 0;
}

/* clears the ‘X’ from Chrome */
input[type="search"]::-webkit-search-decoration,
input[type="search"]::-webkit-search-cancel-button,
input[type="search"]::-webkit-search-results-button,
input[type="search"]::-webkit-search-results-decoration {
  display: none;
}
</style>
